import React from 'react';
import { motion } from 'framer-motion';
import { Wrench, Briefcase, ArrowRight, GraduationCap } from 'lucide-react';
const TRACKS = [{
  icon: Wrench,
  eyebrow: 'Diplomado 01',
  title: 'Capacidades técnicas',
  description: 'Orientado al fortalecimiento de capacidades técnicas para la gestión de la información ambiental y territorial.',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80'
}, {
  icon: Briefcase,
  eyebrow: 'Diplomado 02',
  title: 'Capacidades gerenciales',
  description: 'Orientado al fortalecimiento de capacidades gerenciales para la toma de decisiones en el sector ambiental.',
  image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&q=80'
}];
export function DiplomadosVirtuales() {
  return <section id="diplomados" className="py-24 md:py-32 px-4 md:px-8 scroll-mt-24" data-id="element-97">
      <div className="max-w-[1400px] mx-auto" data-id="element-98">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-99">
          <div className="lg:col-span-5" data-id="element-100">
            <span className="block text-clay uppercase tracking-[0.2em] text-xs font-semibold mb-5" data-id="element-101">
              Formación complementaria
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-forest leading-[1.05]" data-id="element-102">
              Diplomados virtuales para la gobernanza territorial y ambiental
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3 space-y-5 text-charcoal/80 font-light leading-relaxed" data-id="element-103">
            <p className="text-lg md:text-xl text-charcoal/85" data-id="element-104">
              Entre noviembre de 2024 y marzo de 2025, con el apoyo del
              Ministerio de Ambiente y Desarrollo Sostenible y en alianza con la
              Universidad de Medellín, se diseñaron dos diplomados virtuales:{' '}
              <em className="not-italic font-medium text-charcoal" data-id="element-105">
                "El ordenamiento territorial y ambiental como aporte a la
                gobernanza de los territorios"
              </em>
              .
            </p>
            <p data-id="element-106">
              Estos programas buscan fortalecer la gobernanza y la gestión de la
              información ambiental y territorial para la toma de decisiones.
              Ambos están dirigidos a funcionarios de entidades gubernamentales
              vinculadas al sector ambiental.
            </p>
          </div>
        </div>

        {/* Two tracks */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-107">
          {TRACKS.map((track, i) => {
          const Icon = track.icon;
          return <motion.article key={track.title} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="group relative h-[360px] md:h-[420px] overflow-hidden bg-forest" data-id="element-108">
                <img src={track.image} alt={track.title} className="absolute inset-0 w-full h-full object-cover opacity-50 transition-transform duration-700 group-hover:scale-105" data-id="element-109" />
                <div className="absolute inset-0 bg-forest/50" data-id="element-110" />
                <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-between" data-id="element-111">
                  <div className="w-14 h-14 border-2 border-bone/40 flex items-center justify-center" data-id="element-112">
                    <Icon className="text-bone" size={26} strokeWidth={1.5} data-id="element-113" />
                  </div>
                  <div data-id="element-114">
                    <span className="text-clay-light text-xs uppercase tracking-[0.2em] font-semibold mb-3 block" data-id="element-115">
                      {track.eyebrow}
                    </span>
                    <h3 className="font-serif text-bone text-3xl mb-3 leading-tight" data-id="element-116">
                      {track.title}
                    </h3>
                    <p className="text-bone/80 text-sm font-light leading-relaxed" data-id="element-117">
                      {track.description}
                    </p>
                  </div>
                </div>
              </motion.article>;
        })}
        </div>

        {/* CTA */}
        <motion.a href="#" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="group flex flex-col sm:flex-row sm:items-center justify-between gap-6 bg-bone-dark p-8 md:p-10" data-id="element-118">
          <div className="flex items-center gap-5" data-id="element-119">
            <GraduationCap className="text-clay flex-none" size={36} strokeWidth={1.5} data-id="element-120" />
            <p className="font-serif text-forest text-xl md:text-2xl leading-snug" data-id="element-121">
              Conoce los contenidos, materiales y resultados de estos procesos
              de formación.
            </p>
          </div>
          <span className="inline-flex items-center gap-2 text-clay font-medium flex-none" data-id="element-122">
            Explorar diplomados
            <ArrowRight size={18} className="transform group-hover:translate-x-1 transition-transform" data-id="element-123" />
          </span>
        </motion.a>
      </div>
    </section>;
}